import { useState } from "react";
import { Button, Col, FormControl, FormLabel, Modal, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../../services/PrivateApiService";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import Validator from "../../../services/Validator";
import { useQueryClient } from "react-query";

const AddTeamModal = ({open, setOpen}) => {

    const API = new PrivateApi();
    const VALIDATOR = new Validator();
    const queryClient = useQueryClient();
    const [view, setView] = useState("form");
    const [apiError, setApiError] = useState("");
    const [fieldErrors, setFieldErrors] = useState({});
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");


    const cancelHandler = () => {
        setName("");
        setEmail("");
        setMobile("");
        setFieldErrors({});
        setApiError("");
        setView("form");
        setOpen(false);
    }

    const saveTeamMember = () => {
        // check fields
        var temp = {};
        if (name === "") temp.name = "Vor- und Nachname darf nicht leer sein.";
        if (!name.includes(" ")) temp.name = "Vorname oder Nachname fehlt.";
        if (name.length < 4) temp.name = "Vor- und Nachname zu kurz.";
        if (!VALIDATOR.EmailValid(email)) temp.email = "Ungültige E-Mail-Adresse";

        if (Object.keys(temp).length > 0) {
            return setFieldErrors(temp);
        }

        setView("loading");
        let data = {
            name: name,
            email: email,
            phone: mobile,
        }

        API.post_Partner_employee_save(data)
            .then( () => {
                setView("saved");
                queryClient.invalidateQueries("GET_EMPLOYEES");
            })
            .catch( (err) => {
                if (err.response.data.detail !== undefined) setApiError(err.response.data.detail);
                else setApiError("Unbekannter Fehler aufgetreten.");
                setView("error")
            });
    }

    return (
        <Modal show={open} onHide={() => setOpen(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Neuen Kontakt hinzufügen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    view === "form" ?
                        <>
                            <Row>
                                <Col xl="8">
                                    <FormLabel>Vor- und Nachname</FormLabel>
                                    <FormControl 
                                        value={name} 
                                        onChange={e => setName(e.target.value)} 
                                        isValid={name.includes(" ") && name.length > 3}
                                        isInvalid={fieldErrors.name}
                                    />
                                    <small className="text-danger">{fieldErrors.name}</small>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xl="8">
                                    <FormLabel>Kontakt E-Mail-Adresse</FormLabel>
                                    <FormControl 
                                        value={email} 
                                        onChange={e => setEmail(e.target.value)} 
                                        isValid={VALIDATOR.EmailValid(email)}
                                        isInvalid={fieldErrors.email}
                                    />
                                    <small className="text-danger">{fieldErrors.email}</small>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col xl="6">
                                    <FormLabel>Telefonnummer</FormLabel>
                                    <FormControl value={mobile} onChange={e => setMobile(e.target.value)} />
                                </Col>
                            </Row>
                        </>
                    :
                    view === "loading"?
                        <div className="text-center">
                            <Row>
                                <Col>
                                    <Spinner animation="grow" className="text-energo" style={{marginRight: 5}} />
                                    <Spinner animation="grow" className="text-energo" style={{marginRight: 5}} />
                                    <Spinner animation="grow" className="text-energo" />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <p>Daten werden verarbeitet</p>
                                </Col>
                            </Row>
                        </div>
                    :
                    view === "saved" ?
                        <div className="text-center">
                            <Row>
                                <Col xl="12">
                                    <FaCheckCircle className="text-energo" size={50} />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <p>Neuer Kontakt ist gespeichert!</p>
                                </Col>
                            </Row>
                        </div>
                    :
                    view === "error" ?
                        <div className="text-center">
                            <Row>
                                <Col xl="12">
                                    <FaExclamationCircle className="text-danger" size={50} />
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col>
                                    <p>{apiError}</p>
                                </Col>
                            </Row>
                        </div>
                    :
                    null
                }
            </Modal.Body>
            <Modal.Footer hidden={view === "saved" || view === "loading"}>
                <Button onClick={() => cancelHandler()} className="btn-warning">Abbrechen</Button>
                <Button onClick={() => saveTeamMember()} className="btn-energo">{view === "form"? "Speichern": view === "error"? "Erneut versuchen": null}</Button>
            </Modal.Footer>
        </Modal>
    )
}
export default AddTeamModal;